import { render, staticRenderFns } from "./HeaderCartBundlesWrap.vue?vue&type=template&id=045fd38a"
import script from "./HeaderCartBundlesWrap.vue?vue&type=script&lang=ts"
export * from "./HeaderCartBundlesWrap.vue?vue&type=script&lang=ts"
import style0 from "./HeaderCartBundlesWrap.vue?vue&type=style&index=0&id=045fd38a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports